import React, { useState } from "react";
import SearchWithDropdown from "../../form/front/SearchWithDropdown";
import Button from "../../form/Button";
import JobCarousel from "./JobCarousel";
import { organizationJobUser } from "../../../services/organizationService";
import { useQuery } from "@tanstack/react-query";

const CompanyJobsTab = ({ slug }) => {
  const { data, isLoading } = useQuery({
    queryKey: ["company-job", slug],
    queryFn: async () => {
      if (!slug) return null;
      return await organizationJobUser({ slug });
    },
    enabled: !!slug, // only runs when component mounts
  });

  if (isLoading) return <div className="p-4">Loading Jobs...</div>;

  const jobData = data?.data?.jobData || [];
  const companyImage = data?.data?.logo?.url;

  if (!jobData.length) return <div className="p-4">No jobs available.</div>;
  return (
    <>
      <div className="px-4 py-4 border rounded-lg bg-white shadow-md mt-4 relative">
        <JobCarousel
          jobs={jobData}
          companyImage={companyImage}
          slug={data?.data?.slug}
        />
      </div>
    </>
  );
};

export default CompanyJobsTab;
